<mat-card appearance="outlined" class="mb-10 col-sm-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
  <mat-card-header>
    <button mat-raised-button (click)="updateMeeting(-1)"
            style="position: absolute; right: 10px; top: 10px;" color="accent"><mat-icon>add</mat-icon> Create</button>

    <mat-card-title>
      <mat-icon>groups</mat-icon> Meetings
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="row pt-4 pb-0">
      <mat-form-field label="Search term" class="col-8" appearance="outline" floatLabel="always">
        <mat-label>Search</mat-label>
        <input placeholder="Search term" matInput [(ngModel)]="searchTerm" (blur)="searchMeetings()" (keydown.enter)="searchMeetings()" />

        <div matSuffix>
          <button
            class="d-inline-block"
            (click)="searchMeetings()"
            mat-icon-button
            color="primary" matSuffix>
            <mat-icon>search</mat-icon>
          </button>

          <button
            *ngIf="searchTerm"
            class="d-inline-block"
            (click)="searchTerm = ''; searchMeetings()"
            mat-icon-button
            color="warn" matSuffix>
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </mat-form-field>
    </div>

    <ng-container *ngIf="(searchResults || isSearching)">
      <mat-divider></mat-divider>

      <ng-container *ngIf="isSearching">
        <mat-spinner
          diameter="40"
          class="ml-auto mr-auto d-block mt-50 mb-25" color="primary"></mat-spinner>
        <br/>
      </ng-container>

      <!-- Fake Mat Table for Styling -->
      <mat-table style="display: none; visibility: hidden;">
        <mat-header-row *matHeaderRowDef="[]"></mat-header-row>
      </mat-table>

      <ng-container *ngIf="!isSearching">

        <table mat-table [dataSource]="dataSource" matSort matSortDisableClear class="mat-table w-100" style="max-width: 100%;" *ngIf="searchResults.length > 0">

          <!-- Column -->
          <ng-container matColumnDef="topic">
            <th fxFlex="40%" mat-header-cell *matHeaderCellDef mat-sort-header> Topic </th>
            <td fxFlex="40%" mat-cell *matCellDef="let element" class="ellipsis clickable" (click)="selectMeeting(element)"> {{element.topic}} </td>
          </ng-container>

          <!-- Column --->
          <ng-container matColumnDef="date">
            <th fxFlex="15%" mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
            <td fxFlex="15%" mat-cell *matCellDef="let element" class="ellipsis clickable" (click)="selectMeeting(element)"> {{ element.date | amFromUnix | amDateFormat:'DD/MM/YYYY' }} </td>
          </ng-container>

          <!-- Column -->
          <ng-container matColumnDef="attendees">
            <th fxFlex="15%" mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Attendees </th>
            <td fxFlex="15%" mat-cell *matCellDef="let element" class="ellipsis text-center clickable" (click)="selectMeeting(element)"> {{ element.attendees }} </td>
          </ng-container>

          <!-- Column -->
          <ng-container matColumnDef="properties">
            <th fxFlex="15%" mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Properties </th>
            <td fxFlex="15%" mat-cell *matCellDef="let element" class="ellipsis text-center clickable" (click)="selectMeeting(element)"> {{ element.properties }} </td>
          </ng-container>

          <ng-container matColumnDef="edit">
            <th fxFlex="10%" mat-header-cell *matHeaderCellDef> </th>
            <td fxFlex="10%" mat-cell *matCellDef="let element" class="text-right">
              <button mat-icon-button [mat-menu-trigger-for]="meetingMenu" [matMenuTriggerData]="{meeting: element}">
                <mat-icon>more_vert</mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <mat-paginator *ngIf="searchResults.length > 0" [pageSizeOptions]="[20, 50, 100]" showFirstLastButtons></mat-paginator>

        <div *ngIf="(searchTerm || searchCategory) && searchResults && searchResults.length === 0" class="text-center mt-20 mb-20">
          <mat-icon style="width: 50px; height: 50px; font-size: 50px;">search</mat-icon><br/>
          <h2>Nothing found for search term..</h2>
        </div>

      </ng-container>

    </ng-container>

  </mat-card-content>
</mat-card>


<!-- Menu -->
<mat-menu #meetingMenu="matMenu" [overlapTrigger]="false">
  <ng-template matMenuContent let-meeting="meeting">
    <button mat-menu-item (click)="selectMeeting(meeting)">
      <mat-icon>open_in_full</mat-icon>
      <span>Open</span>
    </button>
    <button mat-menu-item (click)="updateMeeting(meeting.id)">
      <mat-icon>edit</mat-icon>
      <span>Edit</span>
    </button>
    <button mat-menu-item (click)="downloadMeeting(meeting.id)">
      <mat-icon>download</mat-icon>
      <span>Download attendance</span>
    </button>
    <button mat-menu-item (click)="deleteMeeting(meeting.id)">
      <mat-icon>delete</mat-icon>
      <span>Delete</span>
    </button>
  </ng-template>
</mat-menu>

